import type { CSSProperties } from 'react';

const VIEW_BOX_WIDTH = 247.35;
const VIEW_BOX_HEIGHT = 60.66;

export function TrinityLogo({ height = 32, style }: { height?: number; style?: CSSProperties }) {
  const width = (height * VIEW_BOX_WIDTH) / VIEW_BOX_HEIGHT;
  return (
    <svg
      viewBox={`0 0 ${VIEW_BOX_WIDTH} ${VIEW_BOX_HEIGHT}`}
      width={width}
      height={height}
      role="img"
      aria-label="Trinity"
      style={{ display: 'block', ...style }}
    >
      <defs>
        <linearGradient id="trinity-grad-addin" x1={0.594727} x2={26.2904} y1={52.3768} y2={0.434374} gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#FF6150" />
          <stop offset={1} stopColor="#6B12ED" />
        </linearGradient>
      </defs>
      <g>
        <path d="M60.79 49.79h-3.36V23.45h-9.87v-3.07h23.1v3.07h-9.87ZM102.2 49.79l-8.53-11.43h-8.4v11.43H82V20.38h12.6c6.47 0 10.63 3.49 10.63 8.78 0 4.92-3.36 7.77-8 8.61l9 12Zm-7.85-26.34h-9.08v11.93h9c4.42 0 7.57-2.27 7.57-6.09.03-3.66-2.75-5.84-7.49-5.84ZM121 20.38v29.41h-3.3V20.38ZM156.34 20.38h3.23v29.41h-2.64l-19-24.12v24.12h-3.23V20.38h3.1L156.34 44ZM176.58 20.38v29.41h-3.32V20.38ZM201.4 49.79H198V23.45h-9.87v-3.07h23.1v3.07h-9.83ZM235.13 49.79h-3.36V38.15l-12.23-17.77h4l9.91 14.7 10-14.7h3.86l-12.18 17.73Z" />
        <path
          d="M6 30.45v27.19a3 3 0 1 1-6 0V30.45a3 3 0 1 1 6 0Zm9-22a3 3 0 0 0-3 3v37.2a3 3 0 1 0 6 0V11.48a3 3 0 0 0-3-3.02ZM27.31 0a3 3 0 0 0-3 3v27.39a3 3 0 1 0 6 0V3a3 3 0 0 0-3-3Z"
          fill="url(#trinity-grad-addin)"
        />
      </g>
    </svg>
  );
}
